import { useContext } from 'react';
//
import { ConnectedAppsContext } from '../contexts/Connectors';
// import { AuthContext } from '../contexts/Auth0Context';
// import { AuthContext } from '../contexts/FirebaseContext';
// import { AuthContext } from '../contexts/AwsCognitoContext';

// ----------------------------------------------------------------------

const useConnector = () => {
  const context = useContext(ConnectedAppsContext);

  if (!context) throw new Error('Auth context must be use inside AuthProvider');

  return context;
};

export default useConnector;
